export default __webpack_public_path__ + "static/media/Snd_TryQ.da25ee18.mp3";